import { logger } from "@services/workers/helpers";
import ObjectsOperations from "@utils/objects/operations";
import StorageUtils from "@services/storage";
import { TemplateTEMPObject } from "@services/storage/storeTemplate";
import { templateState, storeName } from "../slice";
import { dispatchHydrateTemp, dispatchResetTemp, dispatchSaveTemp } from "..";

const namespace = "TempReducer";

export const hydrateTempReducer = () => {
  const newState = ObjectsOperations.typeSafeStructuredClone<TemplateTEMPObject>(templateState);
  for (const key in newState) {
    const value = StorageUtils.getFromStorage({ type: "local", store: storeName, key });
    if (value) newState[key as keyof typeof newState] = value as never;
  }
  logger.debug(namespace + "->" + hydrateTempReducer.name, "Data loaded");

  dispatchHydrateTemp(newState);
  dispatchSaveTemp();
};

// resetTemp to initial state
export const resetTempReducer = () => {
  logger.debug(namespace + "->" + resetTempReducer.name, "Resetting state");
  dispatchResetTemp();
  dispatchSaveTemp();
};

// importTemp to state
export const importTempReducer = (temp: TemplateTEMPObject) => {
  logger.debug(namespace + "->" + importTempReducer.name, "Importing state");
  dispatchHydrateTemp(temp);
  dispatchSaveTemp();
};
